import * as actionTypes from './actionTypes';
import signUpService from 'services/signUpService';

export const fetchingCompaniesToUser = domain => {
  return dispatch => {
    signUpService
      .companiesToUser({ companyDomain: domain })
      .then(companies => {
        dispatch(setCompaniesToUser(companies));
      })
      .catch(err => {
        dispatch(requestFailed(err));
      });
  };
};

export const requestSignup = user => {
  return dispatch => {
    signUpService
      .sendDetails(user)
      .then(res => {
        dispatch(requestSignupSuccessful(user));
      })
      .catch(err => {
        dispatch(requestFailed(err));
      });
  };
};

export const createNewUserByEmail = email => {
  return dispatch => {
    signUpService
      .createNewUserByEmail(email)
      .catch(err => dispatch(requestFailed(err)));
  };
};

const requestFailed = errorMessage => {
  return {
    type: actionTypes.REQUEST_FAILED,
    errorMessage: errorMessage.errors[0].message
      ? `${errorMessage.message}: ${errorMessage.errors[0].message}`
      : errorMessage.message,
  };
};

export const closeModalErrorFailed = () => {
  return {
    type: actionTypes.CLOSE_MODAL_ERROR,
  };
};

const setCompaniesToUser = companies => {
  return {
    type: actionTypes.SET_COMPANIES_TO_USER,
    companies: companies,
  };
};

const setCompany = idBusiness => {
  return {
    type: actionTypes.SELECT_COMPANY,
    idBusiness: idBusiness,
  };
};

export const closeSignup = () => {
  return {
    type: actionTypes.CLOSE_SIGNUP,
  };
};

export const closeEmailConfirmation = () => {
  return {
    type: actionTypes.CLOSE_EMAIL_CONFIRMATION,
  };
};

export const requestSignupSuccessful = user => {
  return {
    type: actionTypes.REQUEST_SIGNUP_SUCCESSFUL,
    signUpFinished: true,
    user: user,
  };
};

export const selectCompany = idBusiness => {
  return dispatch => {
    dispatch(setCompany(idBusiness));
  };
};

export const setReferalFriendCode = combinedToken => {
  return {
    type: actionTypes.SIGNUP_SET_REFERAL_FRIEND_CODE,
    referalFriendCode: combinedToken,
  };
};

export const setLinkCode = code => {
  return {
    type: actionTypes.SIGNUP_SET_LINK_CODE,
    code: code,
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/SignUp.js